import { TmcContextService } from './../../../../../common/tmc-context.service';
import { Component, Input } from '@angular/core';
import { MatDialog,} from '@angular/material/dialog';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { DashboardDialogService } from '@sdbn/common';
import { DashboardContext } from '@sdbn/common';

import { TMCClientParameters } from '@sdbn/tmc-common';
import { AssignTransportToStation, AvailableTransport, CreatePlannedAssignment, MovementOrderRequest, TransportStationAssignment } from '../../model/sac-client.model';
import { SacBeginUmbrueckungDialogComponent } from '../umbrueckung/sac-begin-umbrueckung-dialog.component';
import { Station } from '../../../../../client/model/station';
import { DialogService } from '@sdbn/common';
import { LoadingZoneSelectionComponent } from '../loading-zone-selection/loading-zone-selection.component';
import { LoadingZoneReference } from '../../../../../client/model/station-usage.model';
import { TransportDetailsLayoutService } from '../../../../../components/transport-details/transport-details-layout.service';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { StationSet } from '../../../../../client/model/station-set';
import { TransportDetailLayout, TransportDetailMode } from '../../../../../common/configuration/transport.configuration';
import { TransportDetailsLayoutConverter } from '../../../../../common/components/tmp/transport-details-layout-converter.service';

@Component({
  selector: 'app-transport-details-list-entry',
  templateUrl: './transport-details-list-entry.component.html',
  styleUrls: ['./transport-details-list-entry.component.scss']
})
export class TransportDetailsListEntryComponent {

  TransportDetailMode = TransportDetailMode;

  featureUmbrueckungEnabled = false;
  featureMovingOrderActive = false;

  responseMessages: ResponseMessage[];

  isLoading = false;

  layoutDefinition: TransportDetailLayout;

  // sacClientContext: SacClientContext;
  selectionSubscription: Subscription;
  @Input() station: Station;
  @Input() stationSet: StationSet;

  @Input() transport: AvailableTransport;
  @Input() dashboardContext: DashboardContext;

  constructor(
    public translationService: TranslationService,
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private dashboardDialogService: DashboardDialogService,
    private dialog: MatDialog,
    private appServerAPI: AppServerAPI,
    private configurationService: AppClientConfigurationService,
    private tmcContextService: TmcContextService,
    private dialogService: DialogService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {

    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentTransportDetailsGridLayout()
    );
    this.featureUmbrueckungEnabled = this.configurationService.isPropertyTrue(TMCClientParameters.FEATURES_UMBRUECKUNG, false);
    this.featureMovingOrderActive = this.configurationService.isPropertyTrue('features.moving-order', false);
  }

  public showTransportInfos() {

    let dashboardContext: DashboardContext = null;

    if (this.dashboardContext != null) {
      dashboardContext = this.dashboardContext;
    } else {
      dashboardContext = new DashboardContext();
    }

    dashboardContext.setContextValue('selected-transport', {
      id: this.transport.id,
      transportName: this.transport.transport.transportName,
      transportScope: this.transport.transport.scope
    });
    this.dashboardDialogService.openTransportDetailsDialog(dashboardContext);
  }

  public assignTransportToStation() {

    // wenn es loading zones gibt dann abfragen
    if (this.station.stationUsage.requiresLoadingZone) {
      this.dialogService.openDefault(LoadingZoneSelectionComponent, { station: this.station }).afterClosed().subscribe(
        result => {
          if (result != null) {
            this.doAssignment(result);
          }
        }
      );
    } else {
      this.doAssignment(null);
    }

  }


  private doAssignment(loadingZone: LoadingZoneReference) {
    this.isLoading = true;
    this.responseMessages = [];

    const assignment = new AssignTransportToStation();
    assignment.transportStationAssignment = {
      station: { id: this.station.id }, transport: { id: this.transport.id }
    };
    assignment.asBackup = this.transport.asBackup;
    assignment.workingStationSet = { id: this.stationSet.id };
    if (loadingZone != null) {
      assignment.loadingZoneId = loadingZone.id;
    }

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/assign-transport', assignment).pipe(
      map(sr => new ServiceResponse(sr)))
      .subscribe(response => {
        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      });
  }

  public startUmbrueckung() {

    this.isLoading = true;
    this.responseMessages = [];

    const sourceTransportAssignment = new TransportStationAssignment();
    sourceTransportAssignment.transport = { id: this.transport.id };
    sourceTransportAssignment.station = { id: this.transport.currentStationId };

    const selectedStation = this.tmcContextService.findStationById(this.station.id);

    const targetTransportAssignment = new TransportStationAssignment();
    targetTransportAssignment.transport = { id: selectedStation.stationUsage.transports[0].id };
    targetTransportAssignment.station = { id: selectedStation.id };

    const dialogRef = this.dialog.open(SacBeginUmbrueckungDialogComponent, {
      data: {
        sourceTransportAssignment,
        targetTransportAssignment
      },
      panelClass: 'tmc-dialog-container',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(
      response => {
        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response?.responseMessages;
        this.isLoading = false;
      }
    );

  }

  public cancelUmbrueckung() {
    this.isLoading = true;
    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.transport.id };
    assignment.station = { id: this.transport.currentStationId };

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/cancel-umbrueckung', assignment).subscribe(
      response => {

        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;
        this.isLoading = false;

      }, error => {
        console.log('Unexpected error' + error);
      }
    );
  }

  public completeUmbrueckung() {

    this.isLoading = true;
    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.transport.id };
    assignment.station = { id: this.transport.currentStationId };

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/complete-umbrueckung', assignment).subscribe(
      response => {

        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;
        this.isLoading = false;

      }, error => {
        console.log('Unexpected error' + error);
      }
    );
  }

  createMovementOrder() {

    this.isLoading = true;


    const movementOrderRequest = new MovementOrderRequest({
      transportId: this.transport.id,
      targetStationId: this.station.id,
      currentStationId: this.transport.currentStationId
    });

    console.log('movement order is', movementOrderRequest);

    this.appServerAPI.execute<ServiceResponse>('/client/control/sac-client/create-moving-order', movementOrderRequest).subscribe(
      response => {

        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;
        this.isLoading = false;

      }, error => {
        console.log('Unexpected error' + error);
      }
    );

  }

  planAssignment() {

    this.isLoading = true;
    this.responseMessages = [];

    const assignment = new CreatePlannedAssignment();
    assignment.plannedTransport = { id: this.transport.id };
    assignment.targetStation = { id: this.station.id };

    this.appServerAPI.execute<ServiceResponse>(`/client/control/sac-client/plan-transport-assignment`, assignment).
      pipe(map(sr => new ServiceResponse(sr))).subscribe(response => {
        this.tmcContextService.forceRefreshOfStationUsages();
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
      }, error => {
        console.error(error);
        this.isLoading = false;
      });

  }

  triggerUsageRefresh() {
    if (this.dashboardContext != null) {
      this.dashboardContext.setContextValue('transport-changed', new Date().getTime());
    }
  }

}
